export const permissionPaths = {
  administration: {
    manageUsers: "Administration.Users.Manage",
    manageRoles: "Administration.Roles.Manage",
    viewAuditLogs: "Administration.AuditLogs.View",
    viewErrorLogs: "Administration.ErrorLogs.View"
  },
  clientSearch: {
    display: "Client.Search.Display"
  },
  clientApplications: {
    display: "Client.Applications.Display",
    add: "Client.Applications.Add"
  },
  applicationForm: {
    display: "Application.Form.Display",
    update: "Application.Form.Update"
  },
  screening: {
    display: "Application.Screening.Display",
    update: "Application.Screening.Update"
  },
  faceSheet: {
    display: "Application.FaceSheet.Display",
    update: "Application.FaceSheet.Update"
  },
  documents: {
    display: "Application.Documents.Display",
    add: "Application.Documents.Add",
    delete: "Application.Documents.Delete"
  },
  costEstimate: {
    display: "Application.CostEstimate.Display",
    add: "Application.CostEstimate.Add",
    update: "Application.CostEstimate.Update",
    delete: "Application.CostEstimate.Delete"
  },
  transitionPlan: {
    display: "Application.TransitionPlan.Display",
    add: "Application.TransitionPlan.Add",
    update: "Application.TransitionPlan.Update",
    delete: "Application.TransitionPlan.Delete"
  },
  applicationHistory: {
    display: "Application.History.Display",
    add: "Application.History.Add",
    update: "Application.History.Update"
  },
  housing: {
    display: "Application.Housing.Display",
    update: "Application.Housing.Update"
  },
  transitionChecklist: {
    display: "Application.TransitionChecklist.Display",
    update: "Application.TransitionChecklist.Update"
  },
  expenditureWorksheet: {
    display: "Application.ExpenditureWorksheet.Display",
    add: "Application.ExpenditureWorksheet.Add",
    update: "Application.ExpenditureWorksheet.Update",
    delete: "Application.ExpenditureWorksheet.Delete"
  },
  notes: {
    caseManagementDisplay: "Application.CaseManagementNotes.Display",
    caseManagementAdd: "Application.CaseManagementNotes.AddNote",
    caseManagementUpdateOwn: "Application.CaseManagementNotes.UpdateOwn",
    caseManagementUpdateAll: "Application.CaseManagementNotes.UpdateAll",
    housingDisplay: "Application.HousingNotes.Display",
    housingAdd: "Application.HousingNotes.AddNote",
    housingUpdateOwn: "Application.HousingNotes.UpdateOwn",
    housingUpdateAll: "Application.HousingNotes.UpdateAll",
    hdiDisplay: "Application.HDINotes.Display",
    hdiAdd: "Application.HDINotes.AddNote",
    hdiUpdateOwn: "Application.HDINotes.UpdateOwn",
    hdiUpdateAll: "Application.HDINotes.UpdateAll"
  },
  participantDirectedServices: {
    display: "Application.PDS.Display",
    add: "Application.PDS.Add",
    update: "Application.PDS.Update",
    delete: "Application.PDS.Delete"
  },
  clientIncidents: {
    display: "Client.Incidents.Display",
    add: "Client.Incidents.Add",
    update: "Client.Incidents.Update"
  },
  reports: {
    display: "Reports.Display"
  }
};

export const hasPermission = (permissions, permission) => {
  return Boolean(permission) && (permissions ?? []).includes(permission);
};

export const hasAnyPermission = (permissions, requiredPermissions) => {
  const normalized = (requiredPermissions ?? []).filter(Boolean);

  return normalized.length === 0 || normalized.some(permission => hasPermission(permissions, permission));
};

export const applicationLandingPages = [
  { segment: "", permission: permissionPaths.applicationForm.display, path: (applicationId) => `/Client/Applications/${applicationId}` },
  { segment: "screening", permission: permissionPaths.screening.display, path: (applicationId) => `/Client/Applications/${applicationId}/screening` },
  { segment: "facesheet", permission: permissionPaths.faceSheet.display, path: (applicationId) => `/Client/Applications/${applicationId}/facesheet` },
  { segment: "documentupload", permission: permissionPaths.documents.display, path: (applicationId) => `/Client/Applications/${applicationId}/documentupload` },
  { segment: "costestimate", permission: permissionPaths.costEstimate.display, path: (applicationId) => `/Client/Applications/${applicationId}/costestimate` },
  { segment: "transitionplan", permission: permissionPaths.transitionPlan.display, path: (applicationId) => `/Client/Applications/${applicationId}/transitionplan` },
  { segment: "appstatus", permission: permissionPaths.applicationHistory.add, path: (applicationId) => `/Client/Applications/${applicationId}/appstatus` },
  { segment: "housing", permission: permissionPaths.housing.display, path: (applicationId) => `/Client/Applications/${applicationId}/housing` },
  { segment: "transitionchecklist", permission: permissionPaths.transitionChecklist.display, path: (applicationId) => `/Client/Applications/${applicationId}/transitionchecklist` },
  { segment: "history", permission: permissionPaths.applicationHistory.display, path: (applicationId) => `/Client/Applications/${applicationId}/history` },
  { segment: "expenditureworksheet", permission: permissionPaths.expenditureWorksheet.display, path: (applicationId) => `/Client/Applications/${applicationId}/expenditureworksheet` },
  { segment: "casemanagementnotes", permission: permissionPaths.notes.caseManagementDisplay, path: (applicationId) => `/Client/Applications/${applicationId}/casemanagementnotes` },
  { segment: "noteshousing", permission: permissionPaths.notes.housingDisplay, path: (applicationId) => `/Client/Applications/${applicationId}/noteshousing` },
  { segment: "hdinotes", permission: permissionPaths.notes.hdiDisplay, path: (applicationId) => `/Client/Applications/${applicationId}/hdinotes` },
  { segment: "pds", permission: permissionPaths.participantDirectedServices.display, path: (applicationId) => `/Client/Applications/${applicationId}/pds` }
];

export const getApplicationLandingPath = (permissions, applicationId) => {
  const landingPage = applicationLandingPages.find(page => hasPermission(permissions, page.permission));

  return landingPage?.path(applicationId) ?? null;
};

export const quickLinkPermissionBySegment = {
  ...Object.fromEntries(applicationLandingPages.map(page => [page.segment, page.permission]))
};

export const getQuickLinkPermission = (link) => {
  const segment = (link?.url ?? "").trim().replace(/^\/+|\/+$/g, "").toLowerCase();

  return quickLinkPermissionBySegment[segment] ?? null;
};

export const canAccessQuickLink = (permissions, link) => {
  const permission = getQuickLinkPermission(link);

  return hasPermission(permissions, permission);
};
